document.addEventListener('DOMContentLoaded', function() {
  const I18N = window.MGM_I18N || {
    video_pause: 'Pause the video', video_play: 'Play the video',
    video_mute: 'Mute', video_unmute: 'Unmute',
    video_fullscreen: 'Fullscreen', video_exit_fullscreen: 'Exit fullscreen'
  };
  const faqItems = document.querySelectorAll('.mgm-faq-item');
  
  // Initialiser toutes les réponses comme fermées
  faqItems.forEach(item => {
    const answer = item.querySelector('.mgm-faq-answer');
    answer.style.maxHeight = "0px";
  });
  
  faqItems.forEach(item => {
    const question = item.querySelector('.mgm-faq-question');
    const answer = item.querySelector('.mgm-faq-answer');
    
    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('active');
        const otherAnswer = otherItem.querySelector('.mgm-faq-answer');
        otherAnswer.style.maxHeight = "0px";
      });
      
      if (!isActive) {
        item.classList.add('active');
        const height = answer.scrollHeight;
        setTimeout(() => {
          answer.style.maxHeight = height + 50 + "px"; // Ajouter 50px pour plus de sécurité
        }, 10);
      }
    });
  });
  
  // Ouvrir le premier élément FAQ par défaut
  if (faqItems.length > 0) {
    const firstItem = faqItems[0];
    const firstAnswer = firstItem.querySelector('.mgm-faq-answer');
    firstItem.classList.add('active');
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 50 + "px"; // Ajouter 50px pour plus de sécurité
  }
  
  // Ajuster la hauteur en cas de redimensionnement de la fenêtre
  window.addEventListener('resize', function() {
    const activeItem = document.querySelector('.mgm-faq-item.active');
    if (activeItem) {
      const activeAnswer = activeItem.querySelector('.mgm-faq-answer');
      activeAnswer.style.maxHeight = activeAnswer.scrollHeight + 50 + "px";
    }
  });
  
  // Gestion du bouton sticky d'ajout au panier sur mobile
  const stickyCartMobile = document.querySelector('.mgm-sticky-cart-mobile');
  const productSections = document.querySelectorAll('.mgm-product-section');
  const stickyAddToCartButton = document.getElementById('mgm-sticky-add-to-cart-button');
  const cartDrawer = document.getElementById('cart-drawer');
  
  if (stickyCartMobile && productSections.length > 0 && window.innerWidth < 992) {
    const firstSection = productSections[0];
    
    // Afficher le bouton immédiatement
    stickyCartMobile.classList.add('visible');
    
    // Fonction pour vérifier si on est entre la première section et la fin de la page
    function checkStickyButtonVisibility() {
      const firstSectionTop = firstSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      const cartDrawer = document.getElementById('cart-drawer');
      const isCartDrawerOpen = cartDrawer && cartDrawer.getAttribute('open') === 'true';

      if (firstSectionTop < windowHeight && !isCartDrawerOpen) {
        stickyCartMobile.classList.add('visible');
      } else {
        stickyCartMobile.classList.remove('visible');
      }
    }
    
    // Initialiser l'état du bouton au chargement
    checkStickyButtonVisibility();
    
    // Écouter l'événement de défilement
    let stickyScrollTicking = false;
    window.addEventListener('scroll', function () {
      if (stickyScrollTicking) return;
      stickyScrollTicking = true;
      requestAnimationFrame(function () {
        checkStickyButtonVisibility();
        stickyScrollTicking = false;
      });
    }, { passive: true });
    
    // Observer les changements sur l'élément de panier kaching (si utilisé)
    const kachingCartElement = document.getElementById('kaching-cart');
    if (kachingCartElement) {
      const kachingCartObserver = new MutationObserver(checkStickyButtonVisibility);
      kachingCartObserver.observe(kachingCartElement, { attributes: true, attributeFilter: ['data-open'] });
    }
    
    // Observer les changements sur l'attribut 'open' de cart-drawer
    if (cartDrawer) {
      const cartDrawerObserver = new MutationObserver(checkStickyButtonVisibility);
      cartDrawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
    }
    
    // Écouter les changements de variante pour mettre à jour le prix du bouton sticky
    document.addEventListener('variant:changed', function(event) {
      if (event.detail && event.detail.variantId && stickyAddToCartButton) {
        stickyAddToCartButton.setAttribute('data-variant-id', event.detail.variantId);
        
        if (event.detail.price) {
          const priceDisplay = stickyAddToCartButton.querySelector('.mgm-sticky-cart-price');
          if (priceDisplay) {
            priceDisplay.textContent = event.detail.price;
          }
          
          // Mettre à jour le prix comparé sur le bouton si disponible
          if (event.detail.comparePrice) {
            const comparePriceDisplay = stickyAddToCartButton.querySelector('.mgm-sticky-cart-compare-price');
            if (comparePriceDisplay) {
              comparePriceDisplay.textContent = event.detail.comparePrice;
              comparePriceDisplay.style.display = 'inline';
            }
          } else {
            const comparePriceDisplay = stickyAddToCartButton.querySelector('.mgm-sticky-cart-compare-price');
            if (comparePriceDisplay) {
              comparePriceDisplay.style.display = 'none';
            }
          }
        }
      }
    });
    
    // Gérer le clic sur le bouton sticky
    if (stickyAddToCartButton) {
      stickyAddToCartButton.addEventListener('click', function() {
        // Si le mode packs par taille est actif, déléguer au bouton principal (packs multi-unités)
        const packWrapper = document.querySelector('.mgm-variant-selector-wrapper[data-size-color-map]');
        const mainAtcButton = document.getElementById('mgm-add-to-cart-button');
        if (packWrapper && mainAtcButton) {
          mainAtcButton.click();
          return;
        }

        // Récupérer l'ID de la variante
        const variantId = this.getAttribute('data-variant-id');

        // Désactiver le bouton pendant le traitement
        this.disabled = true;
        const originalText = this.querySelector('.mgm-sticky-cart-text').textContent;
        this.querySelector('.mgm-sticky-cart-text').textContent = 'Ajout en cours...';
        
        // Utiliser l'API Ajax de Shopify pour ajouter au panier
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          // Succès - mettre à jour l'interface utilisateur
          stickyAddToCartButton.querySelector('.mgm-sticky-cart-text').textContent = 'Ajouté au panier 😻';
          
          // Mettre à jour les compteurs de panier dans le site
          const cartCountElements = document.querySelectorAll('.cart-count');
          cartCountElements.forEach(element => {
            const currentCount = parseInt(element.textContent) || 0;
            const newCount = currentCount + 1;
            element.textContent = newCount;
            element.style.display = 'flex';
          });
          
          // Déclencher un événement personnalisé
          document.dispatchEvent(new CustomEvent('product:added-to-cart', {
            detail: { product: data }
          }));
          
          // Réinitialiser le bouton après 2 secondes
          setTimeout(function() {
            stickyAddToCartButton.disabled = false;
            stickyAddToCartButton.querySelector('.mgm-sticky-cart-text').textContent = originalText;
          }, 2000);
        })
        .catch(error => {
          console.error('Erreur lors de l\'ajout au panier:', error);
          stickyAddToCartButton.querySelector('.mgm-sticky-cart-text').textContent = 'Erreur. Réessayer';
          
          // Réinitialiser le bouton après 2 secondes
          setTimeout(function() {
            stickyAddToCartButton.disabled = false;
            stickyAddToCartButton.querySelector('.mgm-sticky-cart-text').textContent = originalText;
          }, 2000);
        });
      });
    }
  }
  
  // Code pour les vidéos - Gérer toutes les vidéos sur la page
  const videoWrappers = document.querySelectorAll('.mgm-video-wrapper');
  
  // Variable pour suivre si une vidéo est en cours de lecture
  let isAnyVideoPlaying = false;
  
  // Fonction pour vérifier si une vidéo est en cours de lecture et mettre à jour le bouton sticky
  function updateStickyButtonVisibility() {
    // Récupérer toutes les vidéos
    const allVideos = document.querySelectorAll('.mgm-video');
    // Vérifier si au moins une vidéo est en cours de lecture
    isAnyVideoPlaying = Array.from(allVideos).some(video => !video.paused);
    
    // Masquer le bouton sticky si une vidéo est en cours de lecture
    if (stickyCartMobile) {
      if (isAnyVideoPlaying) {
        stickyCartMobile.classList.add('mgm-hide-sticky');
      } else {
        stickyCartMobile.classList.remove('mgm-hide-sticky');
      }
    }
  }
  
  // Icônes pour les boutons de contrôle
  const pauseIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="10" y1="15" x2="10" y2="9"></line>
      <line x1="14" y1="15" x2="14" y2="9"></line>
    </svg>`;
  
  const playIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polygon points="10 8 16 12 10 16 10 8"></polygon>
    </svg>`;
  
  // Icônes pour les boutons mute/unmute
  const muteIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
      <line x1="23" y1="9" x2="17" y2="15"></line>
      <line x1="17" y1="9" x2="23" y2="15"></line>
    </svg>`;
  
  const unmuteIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
    </svg>`;
  
  // Parcourir chaque wrapper vidéo pour configurer ses contrôles
  videoWrappers.forEach(wrapper => {
    const videoControlBtn = wrapper.querySelector('.mgm-video-control-btn');
    const videoMuteBtn = wrapper.querySelector('.mgm-video-mute-btn');
    const videoFullscreenBtn = wrapper.querySelector('.mgm-video-fullscreen-btn');
    const video = wrapper.querySelector('.mgm-video');
    const videoPlaceholder = wrapper.querySelector('.mgm-video-placeholder');
    const videoPlayOverlay = wrapper.querySelector('.mgm-video-play-overlay');
    const videoControls = wrapper.querySelector('.mgm-video-controls');
    
    if (video && videoPlaceholder && videoPlayOverlay) {
      // S'assurer que la vidéo est en pause au démarrage et cachée
      video.pause();
      video.style.display = 'none';
      videoPlaceholder.style.display = 'block';
      if (videoControls) {
        videoControls.style.display = 'none';
      }
      
      // Gérer le clic sur le bouton play de l'overlay
      videoPlayOverlay.addEventListener('click', function(e) {
        e.stopPropagation();
        startVideo();
      });
      
      // Fonction pour démarrer la vidéo
      function startVideo() {
        // Cacher l'image de remplacement
        videoPlaceholder.style.display = 'none';
        // Afficher la vidéo et les contrôles
        video.style.display = 'block';
        if (videoControls) {
          videoControls.style.display = 'block';
        }
        // Jouer la vidéo
        video.play();
        wrapper.classList.add('playing');
        // Mettre à jour la visibilité du bouton sticky
        updateStickyButtonVisibility();
      }
      
      // Fonction pour arrêter la vidéo et revenir à l'image
      function stopVideo() {
        // Pauser la vidéo
        video.pause();
        // Cacher la vidéo et les contrôles
        video.style.display = 'none';
        if (videoControls) {
          videoControls.style.display = 'none';
        }
        // Afficher l'image de remplacement
        videoPlaceholder.style.display = 'block';
        wrapper.classList.remove('playing');
        // Mettre à jour la visibilité du bouton sticky
        updateStickyButtonVisibility();
      }
      
      if (videoControlBtn) {
        // Mettre l'icône de pause et le label approprié
        videoControlBtn.innerHTML = pauseIcon;
        videoControlBtn.setAttribute('aria-label', I18N.video_pause);

        // Gérer le bouton play/pause
        videoControlBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (video.paused) {
            video.play();
          } else {
            // Au lieu de juste pauser, on revient à l'image
            stopVideo();
          }
        });
      }
      
      // Permettre de cliquer sur la vidéo pour la pauser et revenir à l'image
      video.addEventListener('click', function() {
        stopVideo();
      });
      
      // Mise à jour de l'interface quand la vidéo change d'état
      video.addEventListener('play', function() {
        wrapper.classList.add('playing');
        if (videoControlBtn) {
          videoControlBtn.innerHTML = pauseIcon;
          videoControlBtn.setAttribute('aria-label', I18N.video_pause);
        }
        updateStickyButtonVisibility();
      });
      
      video.addEventListener('pause', function() {
        wrapper.classList.remove('playing');
        if (videoControlBtn) {
          videoControlBtn.innerHTML = playIcon;
          videoControlBtn.setAttribute('aria-label', I18N.video_play);
        }
        updateStickyButtonVisibility();
      });
      
      // Ajouter des détecteurs pour la fin de la vidéo
      video.addEventListener('ended', function() {
        // Quand la vidéo se termine, revenir à l'image
        stopVideo();
      });
      
      // Gestion du bouton mute/unmute si présent
      if (videoMuteBtn) {
        // S'assurer que le son est activé par défaut
        video.muted = false;
        videoMuteBtn.innerHTML = unmuteIcon;
        videoMuteBtn.setAttribute('aria-label', I18N.video_mute);

        videoMuteBtn.addEventListener('click', function() {
          if (video.muted) {
            video.muted = false;
            videoMuteBtn.innerHTML = unmuteIcon;
            videoMuteBtn.setAttribute('aria-label', I18N.video_mute);
          } else {
            video.muted = true;
            videoMuteBtn.innerHTML = muteIcon;
            videoMuteBtn.setAttribute('aria-label', I18N.video_unmute);
          }
        });
      }
      
      // Gestion du bouton plein écran si présent
      if (videoFullscreenBtn) {
        // Reste du code pour le plein écran...
        const enterFullscreenIcon = videoFullscreenBtn.innerHTML;
        const exitFullscreenIcon = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="4 14 10 14 10 20"></polyline>
            <polyline points="20 10 14 10 14 4"></polyline>
            <line x1="14" y1="10" x2="21" y2="3"></line>
            <line x1="3" y1="21" x2="10" y2="14"></line>
          </svg>`;
        
        videoFullscreenBtn.addEventListener('click', function() {
          if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
            videoFullscreenBtn.innerHTML = enterFullscreenIcon;
            videoFullscreenBtn.setAttribute('aria-label', I18N.video_fullscreen);
          } else {
            const requestFullScreen = video.requestFullscreen || 
                                      video.webkitRequestFullscreen || 
                                      video.mozRequestFullScreen || 
                                      video.msRequestFullscreen ||
                                      video.webkitEnterFullscreen;
            
            if (requestFullScreen) {
              requestFullScreen.bind(video)();
              
              if ('webkitEnterFullscreen' in video && !video.paused) {
                video.webkitEnterFullscreen();
              }
              
              videoFullscreenBtn.innerHTML = exitFullscreenIcon;
              videoFullscreenBtn.setAttribute('aria-label', I18N.video_exit_fullscreen);
            }
          }
        });
        
        document.addEventListener('fullscreenchange', updateFullscreenIcon);
        document.addEventListener('webkitfullscreenchange', updateFullscreenIcon);
        document.addEventListener('mozfullscreenchange', updateFullscreenIcon);
        document.addEventListener('MSFullscreenChange', updateFullscreenIcon);
        
        video.addEventListener('webkitbeginfullscreen', function() {
          videoFullscreenBtn.innerHTML = exitFullscreenIcon;
          videoFullscreenBtn.setAttribute('aria-label', I18N.video_exit_fullscreen);
        });
        
        video.addEventListener('webkitendfullscreen', function() {
          videoFullscreenBtn.innerHTML = enterFullscreenIcon;
          videoFullscreenBtn.setAttribute('aria-label', I18N.video_fullscreen);
        });
        
        function updateFullscreenIcon() {
          if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            videoFullscreenBtn.innerHTML = exitFullscreenIcon;
            videoFullscreenBtn.setAttribute('aria-label', I18N.video_exit_fullscreen);
          } else {
            videoFullscreenBtn.innerHTML = enterFullscreenIcon;
            videoFullscreenBtn.setAttribute('aria-label', I18N.video_fullscreen);
          }
        }
      }
    }
  });
}); 